// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__MnURk","title":"footer_title__NMMLj"};